<!--  -->
<template>
  <div class="about-us-box">
    <Atitle :chineseTitle="title.chinese" :enTitle="title.english"></Atitle>
    <div class="content-box">
      <div class="pic-wrapper">
        <div class="signle-pic">
          <img src="../../../assets/images/pic_2.jpeg" alt="" />
        </div>
        <div class="double-pic">
          <img src="../../../assets/images/pic_1.jpeg" alt="" /><img
            src="../../../assets/images/pic_3.png"
            alt=""
          />
        </div>
      </div>
      <div class="text-wrapper" v-html="text"></div>
    </div>
  </div>
</template>

<script>
import Atitle from "../../../components/header/title";
export default {
  name: "",
  data() {
    return {
      title: {
        chinese: "关于我们",
        english: "ABOUT US"
      },
      text:
        `<p>广州默尼信息技术有限公司(以下简称“默尼信息”)成立于2025年，是一家从事医疗健康的互联网企业。我们专注于妇产科领域的深耕发展，拥有了大量的医疗资源。通过深入了解，公司认识到医疗系统中的各项优缺点，本着更好地服务病患，解放医生劳动力，提高综合医疗水平的宗旨，分别面向孕妇妈妈和医生提供专业的健康管理App。</p>
         <p>产品主要涵盖知识宣教、智能穿戴设备等功能，致力于改变妇产科领域现状，实现便捷、专业、高效的服务。为孕妇提供专业线上知识学习平台，用我们的专业守护孕妇渡过整个孕期。同时，我们也为医生提供产科能力培训教育、全国大型学术会议直播等一系列服务，顺应国家医疗体制改革的号召，为各级医生提供了一个良好的交流学习平台，不断提高医生的诊疗水平，加强临床技术。</p>
         <p>默尼信息拥有自己的独立团队，汇聚了IT互联网、医疗行业的各界精英，通过各部门的联合协作，能确保各项目准时、高效、完美地落地。同时，默尼信息跟各大型医院有着紧密的合作关系，为患者提供诊前、线上咨询、出院随访等一系列服务，加强了医患间的沟通，大大提高了患者康复效果。</p>
        `,
        // "<p>广州默尼信息技术有限公司（以下简称“默尼互联网”）成立于2015年，是一家从事移动医疗的互联网企业。几年来，默尼互联网专注于妇产科领域的深耕发展，拥有了大量的医疗资源。通过深入地了解，公司认识到了医疗系统中的各项优缺点，本着更好地服务病患，解放医生劳动力，提高综合医疗水平的宗旨，默尼互联网开发出了两款主打产品：孕e家、Dr默，分别是面向百万孕妇及百万医生的手机APP。</p><p> 孕e家是一款为孕妇及备孕人群量身定做的APP。为用户提供知识宣教、智能穿戴设备等多种功能，致力于改变妇产科领域现状，实现便捷、专业、高效的服务。为孕妇提供了一个专业线上知识学习平台，用我们的专业守护孕妇渡过整个孕期。</p><p> Dr默是为妇产科医生设计的APP。为医生提供产科能力培训教育、全国大型学术会议直播等一系列服务，顺应国家医疗体制改革的号召，为各级医生提供了一个良好的交流学习平台，不断提高医生的诊疗水平，加强临床技术。</p><p> 默尼互联网拥有自己的独立团队，汇聚了IT、医疗、互联网行业的各界精英，通过各部门的联合协作，能确保各项目准时、高效、完美地落地。同时，默尼互联网跟各大型医院有着紧密的合作关系，为患者提供诊前、线下问诊、出院随访等一系列服务，加强了医患间的沟通，大大提高了患者康复效果。</p>"
     
    };
  },

  props: [],

  watch: {},

  components: {
    Atitle
  },

  computed: {},

  created() {},

  methods: {}
};


</script>
<style lang="scss">
.about-us-box {
  width: 100%;
  // min-height: 100vh;
  padding: 50px 350px;
  box-sizing: border-box;
  .content-box {
    width: 100%;
    margin: 75px 0 0 0;
    display: flex;
    .pic-wrapper {
      display: inline-block;
      width: 50%;
      vertical-align: top;
      .signle-pic {
        width: 530px;
        height: 320px;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .double-pic {
        width: 530px;
        height: 260px;
        display: flex;
        img {
          width: 260px;
          height: 100%;
          margin-right: 10px;
          margin-right: 10px\9; // 这是ie的样式
          display: inline-block;
        }
        img:nth-child(2) {
          margin-right: 0;
        }
      }
    }
    .text-wrapper {
      display: inline-block;
      width: 50%;
      vertical-align: top;
      font-size: 18px;
      color: #666;
      line-height: 28px;
      text-align: left;
      p {
        text-indent: 2em;
        margin-bottom: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/aboutUs.vue